<template>
  <!-- 2026-10-02：仅显式启用的主清单显示顶部分页，不改变弹窗/子表和后端分页。 -->
  <div v-if="paginate" class="admin-list-pagination">
    <a-pagination :current="listPaging.current.value" :page-size="listPaging.pageSize.value" :total="listPaging.total.value"
      show-size-changer show-quick-jumper show-less-items @change="listPaging.change" />
  </div>
  <div v-bind="$attrs" ref="container" @scroll="scrollEvent($event)" :class="['table-container', {'responsive-table':responsive,'compact-table':compactEnabled}]" :style="baseStyle" style="border-right:solid 1px #eaeaea">
    <!-- 2026-09-17：显式清单按真实容器共用表头/子表列宽，其他页面沿用正式声明布局。 -->
    <table ref="mainTable" class="main-table" :style="responsive?{width:tableWidth,minWidth:tableWidth}:{}" @mouseleave="mouselevel">
      <!-- 2026-09-17：跨列表题不能决定固定布局列宽，显式colgroup保留重要字段宽度。 -->
      <colgroup v-if="responsive"><col v-if="showSubItems" style="width:26px"><col v-for="(col,index) in cols" :key="index" :style="{width:col.width+'px'}"></colgroup>
      <tr v-if="props.tableTitle">
        <th style="position:sticky;top:0" :colspan="cols.length+(showSubItems?1:0)">{{props.tableTitle}}</th>
      </tr>
      <tr>
        <th v-if="responsive && showSubItems" class="expansion-cell row-fixed" aria-hidden="true"></th>
        <th :colspan="!responsive && cindex===0 && showSubItems?2:1" :class="[...getClassNames(col),'row-fixed', tdCenter ? 'td-center' : '']" :style="cacColumnStyle(col,true,false,cindex)"
        v-for="(col,cindex) in cols" 
        :key="cindex">
        <!-- 2026-09-29：提供可选表头插槽供类型状态说明使用；未提供时保持原表头。 -->
        <slot name="headercell" :column="col"><div style="line-height:14px">{{ col.title }}</div></slot>
        <slot v-if="col.slots?.showSlot" name="selectall" :column="col"></slot>
      </th>
      </tr>
      <template v-if="dataSource.length>0 ">
      <template  v-for="(row,index) in dataSource" >
        <tr v-if="row" @mouseover="handleMouseOver(index)" @click.stop="selectItem(row,index)" :key="index">
          <td v-if="showSubItems" :class="[responsive?'expansion-cell':'legacy-expansion-cell',rowStatus.selectedIndex==index && showSelected?'selected':'']" style="font-size:15px;text-align:center;cursor:pointer;">
          <svg-icon @click="expandClick(row)" v-if="row.subRows && row.subRows.length>0" :icon="row.expand?'expand':'collapse'"></svg-icon>
          </td>
          <td :style="cacColumnStyle(col,false,false,cindex)" 
          :class="[...getClassNames(col),'ellipsis',rowStatus.overIndex==index ?'mover':'', rowStatus.selectedIndex==index?'selected':'', tdCenter ? 'td-center' : '']" 
          v-for="(col,cindex) in cols" :key="cindex">
            <template v-if="!col.layoutPlaceholder">
            <ListText v-if="!col.slots && (col.dataIndex==='orderNumber' || responsive && ['title','productName'].includes(col.dataIndex))" :value="row[col.dataIndex]" :kind="col.dataIndex==='orderNumber'?'order':'product'" />
            <slot v-else-if="col.slots" name="bodycell" :column="col" :record="row" :rowCount="dataSource.length" :rowIndex="index"
            :slots="col.slots" :extend="row.extendColumn"></slot>       
            <div :style="cacColumnStyle(col,false,false,cindex)" v-else-if="props.searchColumn && props.searchColumn.indexOf(col.dataIndex)>=0">
            <template v-if="row.extendColumn">
              <span v-for="(crow,cindex) in row.extendColumn[col.dataIndex]" :key="cindex">
                <span class="hightlight" v-if="props.searchText && crow===props.searchText.value">{{ crow }}</span>
                <span v-else>{{crow}}</span>
              </span>
            </template>
            <div v-else>
              {{row[col.dataIndex]}}
            </div>
            </div>          
            <div v-else-if="col.dataIndex" :title="String(row[col.dataIndex] ?? '')" :style="cacColumnStyle(col,false,true,cindex)" class="ellipsis">{{ row[col.dataIndex] }}</div>
            </template>
          </td>
        </tr>
        <tr v-if="showSubItems && row.subRows && row.subRows.length>0 && row.expand" :key="'subRows'+index">
          <td :colspan="cols.length+(responsive && showSubItems?1:0)" :class="responsive?'expanded-table-cell':''" :style="responsive?{}:{padding:'5px 0'}">
            <table v-if="subTable" :class="['main-table',{'sub-table':responsive}]" :style="responsive?{width:tableWidth,minWidth:tableWidth}:{marginLeft:'10px',borderLeft:'solid 3px green',width:'100%'}"
            @mouseleave="submouselevel(row)">
              <colgroup v-if="responsive"><col v-if="showSubItems" style="width:26px"><col v-for="(col,index) in subcols" :key="index" :style="{width:col.width+'px'}"></colgroup>
              <tr v-if="subTable.tableTitle">
                <th style="position:sticky;top:0" :colspan="subcols.length+(showSubItems?1:0)">{{subTable.tableTitle}}</th>
              </tr>
              <tr v-if="subTable.showHeader">
                <th v-if="responsive && showSubItems" class="expansion-cell row-fixed" aria-hidden="true"></th>
                <th :class="[...getClassNames(subcol),'row-fixed', tdCenter ? 'td-center' : '']" 
                :style="subcacColumnStyle(subcol,true,false,cindex)" v-for="(subcol,cindex) in subcols"
                :key="cindex"><div style="height:14px;line-height: 14px;">{{ subcol.title }}</div></th>
              </tr>
              <template v-if="row.subRows.length>0 ">
              <template  v-for="(subRow,subIndex) in row.subRows" >
                <tr v-if="subRow" @mouseover="subhandleMouseOver(row,subIndex)" @click="subselectItem(row,subRow,subIndex)" :key="subIndex">          
                  <td v-if="responsive && showSubItems" class="expansion-cell th-background" aria-hidden="true"></td>
                  <td class="th-background" :style="subcacColumnStyle(subCol,false,false,cindex)" 
                  :class="[...getClassNames(subCol),'ellipsis',row.subrowStatus?.overIndex==subIndex ?'mover':'', row.subrowStatus?.selectedIndex==subIndex && showSelected?'selected':'', tdCenter ? 'td-center' : '']" 
                  v-for="(subCol,cindex) in subcols" :key="cindex">
                    <template v-if="!subCol.layoutPlaceholder">
                    <ListText v-if="!subCol.slots && (subCol.dataIndex==='orderNumber' || responsive && ['title','productName'].includes(subCol.dataIndex))" :value="subRow[subCol.dataIndex]" :kind="subCol.dataIndex==='orderNumber'?'order':'product'" />
                    <slot v-else-if="subCol.slots" name="bodycell" :column="subCol" :record="subRow" :parentRecord="row" :rowCount="row.subRows.length" :rowIndex="subIndex"
                    :slots="subCol.slots" :extend="subRow.extendColumn"></slot>       
                    <div :style="subcacColumnStyle(subCol,false,false,cindex)" v-else-if="props.searchColumn && props.searchColumn.indexOf(subCol.dataIndex)>=0">
                    <template v-if="subRow.extendColumn">
                      <span v-for="(subcrow,cindex) in subRow.extendColumn[subCol.dataIndex]" :key="cindex">
                        <span class="hightlight" v-if="props.searchText && subcrow===props.searchText.value">{{ subcrow }}</span>
                        <span v-else>{{subcrow}}</span>
                      </span>
                    </template>
                    <div v-else>
                      {{subRow[subCol.dataIndex]}}
                    </div>
                    </div>          
                    <div v-else-if="subCol.dataIndex" :title="String(subRow[subCol.dataIndex] ?? '')" :style="subcacColumnStyle(subCol,false,true,cindex)" class="ellipsis">{{ subRow[subCol.dataIndex] }}</div>
                    </template>
                  </td>
                </tr>
              </template>
            </template>
            </table>
          </td>
        </tr>
      </template>
    </template>
    <template v-else>
      <tr>
        <td :colspan="cols.length+(showSubItems?1:0)" class="no-data">
        <div>
          <img src="@/assets/images/nodata.png" alt="">
          <div>沒有数据</div>
        </div>
        </td>
      </tr>
    </template>
    </table>
  </div>
</template>
<script lang="ts">
// 2026-10-19：按用户要求撤销快递100隐私发货任务，恢复原订单发货及既有功能。
import { defineComponent,PropType,ref,watch ,Ref, computed, provide} from "vue";
import {DataColumns, DataItem,Columns,SubTableOption} from '@/Interfaces/user/DataItem';
import SubTable from './SubTable.vue'
// 2026-10-02：分页复用完整筛选结果，取消启用分页清单的原400行截断。
import { useListPagination } from '@/utils/useListPagination'
// 2026-09-17：仅显式启用的管理列表采用紧凑列宽，默认表格保持原显示。
import ListText from '../ListText.vue'
import { compactColumnWidth } from '@/utils/compactList'
import { resolveTableLayout, declaredTableColumns, readableTableColumns } from '@/utils/responsiveTable'
import { useTableContainer } from '@/utils/useTableContainer'
interface TableDataItem extends DataItem {
  extendColumn?: { [key: string]: string[]};
  name:string,
  selectedIndex?:number,
  subrowStatus?:{selectedIndex:number,overIndex:number}    
}
export default defineComponent({
  name:"FugleTable",
  inheritAttrs:false,
  components:{
    SubTable, ListText
  },
  props:{
    paginate:{type:Boolean,default:false},
    // 2026-09-17：只有四类商家/版师清单显式启用自适应；默认保留正式139声明布局。
    responsive:{type:Boolean,default:false},
    fitColumns:{type:Boolean,default:false},
    compact:{ type:Boolean, default:false },
    tableTitle:{
      type:String,
    },
    data: {
      type: Object as PropType<any[]>,
      required: true
    },
    height:{
      type:String,

    },
    showSubItems:{
      type:Boolean,
      default:false
    },
    columns: {
      type: Object as PropType<DataColumns[]>,
      required: true
    },
    subColumns: {
      type: Object as PropType<DataColumns[]>,
    },
    styles:{
      type:Object,
      default:()=>{return {}}      
    },
    searchColumn:{
      type:Object as PropType<string[]>,
        required: true
    },
    windowWidth:{
      type:Number,
      default:1300
    },
    contentWidth:{
      type:Number,
      default:1800
    },
    searchText:{
      type:Object as PropType<Ref<string>>,
        required: true
    },
    headerStyle:{
      type:Object,
      default:()=>{return {'background-color':'#eef5f9'}}     
    },
    cellCenter:{
      type:Boolean,
      default:false
    },
    enableRowHover:{
      type:Boolean,
      default:true
    },
    pageSize:{
      type:Number,
      default:400
    },
    subTable:{
      type:Object as PropType<SubTableOption>
    },
    showSelected:{
      type:Boolean,
      default:true
    }
  },
  setup(props, { emit }) {
    
    const dSource=ref<any[]>(props.data);
      dSource.value.forEach((itm:any)=>{
        if(!itm.extendColumn)
          itm.extendColumn={}
        if(props.searchColumn){
          for(let col of props.searchColumn){  
            if(props.searchText){
              itm.extendColumn[col]= [itm[col]]
            }
          }
        }
      })
      const subRowClick =(row)=>{
        console.log(row)
        emit('subRowClick',row)
      }
      const expandClick=(row)=>{
        if(row.expand && row.expand==true){
          row.expand=false
        }else{
          row.expand=true
        }
      }
      const filteredRows = computed(() => {
        const searchText = props.searchText?.value;  
        const searchColumns = props.searchColumn;  
        
        if (!searchText || searchColumns.length === 0) {
          if(dSource.value){  
            return dSource.value
          }else{
            return []
          }
        }  
        
        let rrs= dSource.value.filter(itm => {  
          return searchColumns.some(column => {  
            const itemValue = itm[column];  
            return itemValue && itemValue.indexOf(searchText) >= 0;  
          });  
        });  
        return rrs
      });
    const listPaging=useListPagination(()=>filteredRows.value)
    const dataSource=computed(()=>props.paginate ? listPaging.rows.value : filteredRows.value.slice(0,props.pageSize))
    watch(()=>props.data,()=>{
      dSource.value=props.data;
    })
    watch(() => props.searchText, () => {
      if(props.searchText){        
      dataSource.value.forEach((itm:TableDataItem)=>{
          if(!itm.extendColumn)
            itm.extendColumn={}
          if(props.searchColumn){
            for(let col of props.searchColumn){  
              if(props.searchText && itm[col]){
                // 2026-09-17：备注可包含括号等符号，紧凑列表按字面文本高亮，避免正则语法错误。
                const term=props.compact?props.searchText.value.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'):props.searchText.value
                itm.extendColumn[col]= itm[col].toString().split(new RegExp(`(?<=${term})|(?=${term})`, 'i'))
                //console.log(itm.extendColumn)
              }
            }
          }
        }) 
      }
    })
    const tdCenter=computed(()=>props.cellCenter)
    const enableHover=computed(()=>props.enableRowHover)
    // 2026-09-17：深层响应列宽、容器和展开列变化，同字段父子行始终使用同一分配宽度。
    const compactEnabled=computed(()=>props.responsive && props.compact)
    provide('landiyun-responsive-table',computed(()=>props.responsive))
    const {container,width:containerWidth,availableHeight}=useTableContainer(()=>props.responsive)
    const layout=computed(()=>resolveTableLayout(props.fitColumns?readableTableColumns(props.columns):props.columns,props.showSubItems && props.subTable ? props.fitColumns?readableTableColumns(props.subColumns || []):props.subColumns || [] : [],containerWidth.value,props.compact,props.showSubItems?26:0))
    const cols=computed(()=>props.responsive?layout.value.columns:declaredTableColumns(props.columns)),subcols=computed(()=>props.responsive?layout.value.subColumns:declaredTableColumns(props.subColumns || []))
    const tableWidth=computed(()=>(props.responsive?layout.value.width:props.contentWidth)+'px')
    const winWidth=ref(props.windowWidth+'px')
    const mainTable=ref();
    let showLeftShadow=ref(false);
    let showRightShadow=ref(true);
    const rowStatus=ref({
      overIndex:-1,
      selectedIndex:-1
    });
    const subRowStatus=ref({
      overIndex:-1,
      selectedIndex:-1
    });
    // 2026-10-02：翻页后重置行位置状态，避免高亮错落到下一页另一条记录。
    watch([listPaging.current,listPaging.pageSize],()=>{
      rowStatus.value={overIndex:-1,selectedIndex:-1}
      subRowStatus.value={overIndex:-1,selectedIndex:-1}
      if(container.value)container.value.scrollTop=0
    })
    const handleMouseOver=(index:number)=>{
      if(enableHover.value){
      //console.log(enableHover.value)
      rowStatus.value.overIndex=index;
      }
    }
    const mouselevel =() =>{
      rowStatus.value.overIndex=-1
    }
    const selectItem=(item:TableDataItem,index:number)=>{
      rowStatus.value.selectedIndex=index
      emit("rowcick",item)
    }

    const subhandleMouseOver=(row:TableDataItem, index:number|string)=>{
      if(enableHover.value){
      //console.log(enableHover.value)
      subRowStatus.value.overIndex=index as any;
      if(!row.subrowStatus){
        row.subrowStatus={selectedIndex:-1,overIndex:index as any}
      }
      row.subrowStatus.overIndex=index as any
      }
    }
    const submouselevel =(item:TableDataItem) =>{
      subRowStatus.value.overIndex=-1
      if(!item.subrowStatus){
        item.subrowStatus={selectedIndex:-1,overIndex:-1}
      }
      item.subrowStatus.overIndex=-1
    }
    const subselectItem=(row,item:TableDataItem,index:number|string)=>{
      if(!row.subrowStatus){
        row.subrowStatus={selectedIndex:index,overIndex:-1}
      }
      row.subrowStatus.selectedIndex=index
      emit("rowcick",item)
    }
    const getClassNames=(col)=>{ 
      //console.log(col)    
      let classNames:string[]=[];
      if(showLeftShadow.value && col.fixed=='left') classNames.push('shadow-left');
      if(showRightShadow.value && col.fixed=='right') classNames.push('shadow-right');
      if(col.fixed && col.fixed=='right') classNames.push('col-fixed-right');
      if(col.fixed && col.fixed=='left') classNames.push('col-fixed');
      return classNames;
    }
    const scrollEvent=(e)=>{         
        showRightShadow.value=!(e.target.scrollLeft + e.target.clientWidth >= e.target.scrollWidth-2)
        showLeftShadow.value=e.target.scrollLeft>0
    }
    const cacColumnStyle=(col,isHeader,isdiv,index)=>{
      let style = {}
      if(col.width)style['width']=props.responsive && isdiv?'100%':col.width+'px'
      if(props.responsive)style['box-sizing']='border-box'
      if(index==0 && props.showSubItems){
        style['padding-left']='0'
      }
      if(col.fixed=='left' && !isdiv){
        style['left'] = col.fixedWidth+'px'
        if(isHeader){
          style['z-index']=4;
        //style['box-shadow']='0px 0px 5px #ccc'
        }
      }
      if(props.responsive && col.fixed==='right' && !isdiv)style['right']=col.rightOffset+'px'
      if(compactEnabled.value && col.fixed==='right' && isHeader) style['z-index']=5
      if(isHeader){
        if(props.headerStyle){   
          Object.keys(props.headerStyle).forEach((key)=>{
            style[key]=props.headerStyle[key]
          })          
        }
      }
      
      return style
    }
    const subcacColumnStyle=(col,isHeader,isdiv,index)=>{
      const style=cacColumnStyle(col,isHeader,isdiv,index)
      if(!props.responsive && index===0)style['padding-left']='10px'
      return style
    }
    const baseStyle=computed(()=>props.responsive?({
      ...props.styles,width:'100%',minWidth:'0',maxWidth:'100%',
      height:availableHeight.value!==null && props.height?.includes('vh') ? availableHeight.value+'px' : props.height || 'unset',
      ...(availableHeight.value!==null?{maxHeight:availableHeight.value+'px'}:{})
    }):({...props.styles,height:props.height || 'unset'}))
    return {
      listPaging,emit,props,cacColumnStyle,compactColumnWidth,compactEnabled,ref,subRowStatus,baseStyle,subRowClick,scrollEvent,mouselevel,tdCenter,cols,
      subhandleMouseOver,submouselevel,subselectItem,subcacColumnStyle,expandClick,subcols,
      rowStatus,container,mainTable,selectItem,handleMouseOver,showLeftShadow,tableWidth,winWidth,showRightShadow,getClassNames,dataSource
    }
  }
})
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/variables.module.scss';
.table-container{
  // width:v-bind(winWidth);
  /* 2026-09-17：默认恢复正式版视口宽度，显式清单由responsive-table规则随父容器伸缩。 */
  width:calc(100vw - var(--sideBarWidth) - 10px);
  overflow: auto;
  border-left:solid 1px #eaeaea;
  border-bottom:solid 1px #eaeaea;
  
}
.main-table{
    cursor:normal;
    min-width:v-bind(tableWidth);
    width:100%;
    table-layout:auto;
    border-collapse: separate;
    border-spacing:0;
    .no-data{
      text-align: center;
      color:#999999;
      font-size:14px;
      padding:0 20px;
      img{
        width:50px;
      }
    }
    th{
      // background:#eef5f9;

      color:#1a5e62;
      height:35px;
      line-height: 35px;
      padding-left:10px;
      text-align: left;
      font-weight: normal;
      border-top:solid 1px #eaeaea;
      border-bottom:solid 1px rgba(0,0,0,0.2);
      position: sticky;
      top:0;
      text-wrap: nowrap;
    }
    tr{
      height:30px;
      background:#eaeaea;
      line-height: 39px;
    }
    td{
      color:#666666;
      // border-left:solid 1px red;
      // user-select: none;
      height:35px;
      font-size:14px;
      line-height: 35px;
      // text-align: center;
      transition: background 0.3s;
      background:white;
      border-bottom:solid 1px #eaeaea;
      div{
        padding:0 10px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .th-background{
      background:rgb(242,255,242)
    }
    .td-center{
      padding-left:0 !important;
      text-align: center;
    }
    .col-fixed{
      left:0px;
      position:sticky;
      z-index:2;
      
    }
    .col-fixed-right{
      right:0px;
      position:sticky;
      z-index:2;
      
    }
    .row-fixed{
      top:0px;
      position:sticky;
      z-index:3;
    }
    .mover{
      background:#e5f2f2;
    }
    .selected{
       background:#d9e1f4;
    }
  }
.shadow-left {
  box-shadow: 3px 0 3px rgba(0, 0, 0, 0.1);
}
.shadow-right {
  box-shadow: -3px 0 3px rgba(0, 0, 0, 0.1);
}
.hightlight{
  background:yellow;
  color:red;
}
.ellipsis {  
  white-space: nowrap; /* 防止文本换行 */  
  overflow: hidden; /* 隐藏超出容器的内容 */  
  text-overflow: ellipsis; /* 用省略号表示溢出的文本 */   
}
// 2026-09-17：按明确列宽紧凑显示，表头和操作列固定，减少原有重复内边距。
.compact-table {
  min-width:0 !important;
  .main-table { table-layout:fixed; }
  .main-table th { padding:6px; height:30px; }
  .main-table td { padding:2px 6px; }
  .main-table td div { padding-left:0; padding-right:0; }
  .main-table td :deep(.row-command) { gap:8px; }
  .main-table td :deep(.row-command > div) { margin-left:0; margin-right:0; }
  .main-table td :deep(.list-order-number) { max-width:100%; }
}
/* 2026-09-17：新尺寸规则只作用于显式清单，默认样式与正式139相同。 */
.responsive-table{width:100%;min-width:0;max-width:100%;box-sizing:border-box;}
.responsive-table .main-table{table-layout:fixed;}
.main-table td.legacy-expansion-cell{width:20px;padding:0 3px;}
/* 2026-09-17：父子展开列完全对齐，取消子表边框/内边距造成的额外列宽。 */
.main-table .expansion-cell{width:26px;min-width:26px;padding:0;box-sizing:border-box;position:sticky;left:0;z-index:2;}
.main-table th.expansion-cell{z-index:5;}
.main-table td.expanded-table-cell,.compact-table .main-table td.expanded-table-cell{padding:0;border:0;}
.main-table.sub-table{margin:0;border:0;}
</style>
